import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function ProgressiveLoader() {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Simulate progressive loading
    const interval = setInterval(() => {
      setProgress(prev => {
        // Speed up loading as we get closer to completion
        const increment = prev < 50 ? 5 : prev < 80 ? 3 : 1;
        const nextProgress = Math.min(prev + increment, 100);
        
        if (nextProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => setIsComplete(true), 500); // Show completed state briefly
        }
        
        return nextProgress;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-cream">
      <AnimatePresence>
        {!isComplete ? (
          <motion.div 
            className="text-center"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Spinning poop emoji */}
            <motion.div 
              animate={{ 
                rotate: 360,
                scale: [1, 1.1, 1],
              }}
              transition={{ 
                rotate: { 
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "linear" 
                },
                scale: {
                  duration: 1,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut"
                }
              }}
              className="text-[120px] mb-6 inline-block"
            >
              💩
            </motion.div>
            <div className="text-center">
              <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden mx-auto mb-2">
                <motion.div 
                  className="h-full bg-[#8B4513] transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <p className="text-lg text-gray-700">Loading... {progress}%</p>
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}